import { Component } from '@angular/core'
import { appConfig } from '../../../../brands/_current/config/app-config'
import { LoginService } from '../../../login/shared/login.service'

@Component({
  selector: 'app-blocked-account-page',
  templateUrl: './blocked-account-page.component.html',
  styleUrls: ['./blocked-account-page.component.scss'],
})
export class BlockedAccountPageComponent {
  public helplineNumber: string

  constructor(private readonly loginService: LoginService) {
    this.helplineNumber = appConfig.core.helplineNumber
  }

  onBackToLoginPageButton() {
    this.loginService.backToLogin().subscribe()
  }
}
